module.exports = __webpack_public_path__ + "img/secure-disabled.a607b1c2.png";